import { Search } from "lucide-react";

interface SearchInputProps {
  placeholder: string;
  value?: string;
  onChange?: (value: string) => void;
}

export function SearchInput({
  placeholder,
  value,
  onChange,
}: Readonly<SearchInputProps>) {
  return (
    <div
      className={`flex w-full min-w-0 items-center gap-2 ${value ? "text-black" : "text-inp"}`}
    >
      <Search size={20} className="rotate-90 shrink-0" />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
        className="
          w-full min-w-0
          bg-transparent outline-none
          text-base font-normal text-right
          placeholder-gray-400
        "
      />
    </div>
  );
}
